/** @format */

const tokenKey = "trending_anime_auth";
const apiUrl = "https://trendinganime.herokuapp.com/api/v1";
const token = "baa90ccbf1f527590e0f2f19abba3c6590144a7d";
const API_PARAMS = {
	cover_image: "cover_image_url",
	bg_image: "bg_image_url",
};
//const apiUrl = "https://308d-27-5-167-17.ngrok.io/api/v1";
let config = {
	tokenKey,
	token,
	apiUrl,
	API_PARAMS,
};
export default config;
